import {inject, Injectable} from '../di';
import {LegacyPersistentLogService} from './legacy-persistent-log-service';
import $ from 'jquery';
import {Logger} from './logger';
import {UiService} from '../view-engine/ui-service';
import {ConfigService} from '../config/config-service';
import {HotelInfoService} from '../hotel-info-service';
import {RoomNumberService} from '../room-number-service';
import {post} from '../utils/post';

@Injectable()
export class LegacyLogService {
  public readonly persistent = inject(LegacyPersistentLogService);
  private readonly logger = inject(Logger);
  private readonly hotelInfoService = inject(HotelInfoService);
  private readonly roomNumberService = inject(RoomNumberService);
  private readonly configService = inject(ConfigService);

  private readonly zero = Date.now();

  private log: LegacyLogEntry[] = [];

  constructor() {
    window.log = this;
  }

  public add(txt: string, cat?: string) {
    if (!cat) {
      try {
        const match = txt.match(/(.+?): (.+)$/);
        if (match) {
          txt = match[2];
          cat = match[1];
        }
      } catch (err) {
        this.logger.error(`[LegacyLogService] Unable to parse persistent log message: ${txt}`, err);
      }
    }

    const now = Date.now();
    const log_line: LegacyLogEntry = {
      time: (now - this.zero) / 1000,
      cat: cat || undefined,
      text: txt,
    };

    this.log.push(log_line);

    this.logger.log('LOG: ' + (cat ? cat + ': ' : '') + txt);

    // TODO legacy active page
    if (window.active_page_id === 'log') {
      this.out();
      //TODO: добавить условия нахождения в конце списка
      window.scroll_to_bottom();
    }
  }

  public out(all?: boolean, module?: string | -1 | -2) {
    //TODO: get last N rows
    let out = '';
    let prev_text = '';
    let repeat_num = 0;

    const logs = this.getLogs(all);

    for (const entry of logs) {
      if (
        !module ||
        (module == -1 && entry.cat == null) || // unsorted
        (module == -2 && entry.text.match(/error/i)) || // errors
        module == entry.cat
      ) {
        if (prev_text != entry.text) {
          if (repeat_num) {
            out += `== Message repeated ${repeat_num} times ==<br/>`;
            repeat_num = 0;
          }
          const time = entry.time.toFixed(3);
          const cat = entry.cat ? `${entry.cat}: ` : '';
          out += `<span style="font-family: monospace;">${time}:</span> ${cat}${entry.text}<br/>`;
        } else {
          repeat_num++;
        }
        prev_text = entry.text;
      }
    }

    if (repeat_num) {
      out += `== Message repeated ${repeat_num} times ==<br/>`;
    }

    let clone: JQuery<HTMLElement>;
    if (module) {
      if (!document.getElementById('log_module')) {
        clone = $('#sample_page').clone(true);
        clone.attr('id', 'log_module');
        clone.attr('scroll_to_bottom', 'true');
        clone.find('.content').css({width: '100%', margin: '0px'});
        $('#container').append(clone);
      } else {
        clone = $('#log_module');
      }
      if (module == -1) {
        module = 'Unsorted';
      }
      if (module == -2) {
        module = 'Error';
      }
      clone.find('.header').html(`<div class="back" href_type="back" href='#log_modules'></div><h1>${module} Log</h1>`);
      clone.find('.content').html(`<div>${out}</div>`);

      if (window.active_page_id !== 'log_module') {
        // prevent infinite loops
        window.navigate('#log_module', 'now');
      }
    } else {
      if (!document.getElementById('log')) {
        clone = $('#sample_page').clone(true);
        clone.attr('id', 'log');
        clone.attr('scroll_to_bottom', 'true');
        clone.find('.header').html('<h1>Log</h1>');
        $('#container').append(clone);
      } else {
        clone = $('#log');
      }
      if (document.getElementById('tests_logs')) {
        clone.find('.header').html(`<div class="back" href_type="back" href='#tests_logs'></div><h1>Log</h1>`);
      }
      clone.find('.content').html(`<div>${out}</div>`);

      if (window.active_page_id !== 'log') {
        // prevent infinite loops
        window.navigate('#log', 'now');
      }
    }
  }

  public modules() {
    const modules: string[] = [];

    this.log.forEach((entry) => {
      const cat = entry.cat;
      if (cat && !modules.includes(cat)) {
        modules.push(cat);
      }
    });

    let out: string = modules
      .map((module, index) => {
        const topClass = index === 0 ? ' top' : '';
        return `<div class="settings_button${topClass}" onvclick="log.out(true, '${module}');">${module}</div>`;
      })
      .join('');

    out += '<div class="settings_button" onvclick="log.out(true, -1);">Unsorted</div>';
    out += '<div class="settings_button" onvclick="log.out(true, -2);">Errors</div>';
    out += '<div class="settings_button bottom" onvclick="hoteza.loadGuard.toggleOverlay();">Full logs</div>';

    const uiService = inject(UiService);
    if (document.getElementById('tests_logs')) {
      uiService.renderPageOnTheStructv2(
        'log_modules',
        {
          title: 'Logs',
          content: out,
          backBtn: 1,
          parentId: 'tests_logs',
        },
        'information_page',
        'white',
      );
    } else {
      uiService.renderPageOnTheStructv2(
        'log_modules',
        {title: 'Logs', content: out, backBtn: 0},
        'information_page',
        'white',
      );
    }

    window.custom_dialog_close();
    window.navigate('#log_modules');
  }

  public async post(data: object): Promise<void> {
    //TODO: рекурсивная посылка лога;
    //TODO: check for cmd, id, text
    const config = this.configService.config;
    const url = config?.queue_url;

    if (!url) {
      this.logger.error("[LegacyLogService.post] Unable to post logs, no 'queue_url' available");
      return;
    }

    try {
      await post({
        url: `${url}pub/?id=log`,
        data: JSON.stringify(data),
      });
    } catch (err) {
      //TODO: do not send to post
      this.add('log post error');
      this.logger.warn('[LegacyLogService.post] Unable to send logs to the server', err);
    }
  }

  public post_log(text: string) {
    const data = {
      cmd: 'log',
      id: '!!',
      text: text,
      payload: window.tv_get_state(),
    };
    return this.post(data);
  }

  public async post_error(e_text: string, e_url: string, e_line: number): Promise<void> {
    const error: {text: string; url?: string; line?: number} = {
      text: e_text,
    };
    if (e_url) {
      error.url = e_url;
    }
    if (e_line) {
      error.line = e_line;
    }

    const roomNumber = this.roomNumberService.roomNumber$.getValue();
    const config = this.configService.config;
    const url = `${config.stat_url}errorlog/error/`;
    const payload = window.tv_get_state();

    const data = {
      region: this.hotelInfoService.region,
      hotelId: this.hotelInfoService.hotelId,
      room: roomNumber,
      error: error,
      manufacturer: payload.tv_manufacturer,
      model: payload.tv.model,
      firmware: payload.tv.firmware,
      state: {
        p: payload.active_page_id,
        l: payload.language,
        c: payload.tv_cur_elem,
        k: payload.tv_last_key,
        u: payload.uptime,
      },
      version: payload.version,
    };

    try {
      await post({
        url,
        data,
        dataType: 'json',
      });
    } catch (err) {
      this.add('LOG: ERROR: error post error');
      this.logger.warn('[LegacyLogService.post_error] Unable to post error to the server', err);
    }
  }

  public async send() {
    const dataToSend = this.getLogs().map((entry, index) => ({
      cmd: 'log',
      id: index,
      text: entry.time.toFixed(3) + ': ' + entry.text,
    }));

    const n = dataToSend.length;
    if (n === 0) {
      this.logger.log(`[LegacyLogService.send] No logs to send`);
      window.custom_info('No logs to send');
      return;
    }

    window.custom_info('Sending log');

    this.logger.log(`[LegacyLogService.send] Sending ${n} log entries to the server`);

    // send logs one by one
    for (const item of dataToSend) {
      try {
        await this.post(item);
      } catch (err) {
        this.logger.warn('[LegacyLogService.send] Unable to post logs to the server', err);
        // ignore errors, continue sending
      }
    }

    this.logger.log(`[LegacyLogService.send] ${n} log entries were successfully sent to the server.`);
    //TODO: set var to post log on fly
    //TODO: send config
  }

  public console(all: boolean, module: string | -1 | -2) {
    let prev_text = '';
    let repeat_num = 0;

    const logs = this.getLogs(all);

    for (const entry of logs) {
      if (
        !module ||
        (module == -1 && entry.cat == null) || // unsorted
        (module == -2 && entry.text.match(/error/i)) || // errors
        module == entry.cat
      ) {
        if (prev_text != entry.text) {
          if (repeat_num) {
            console.log(`== Message repeated ${repeat_num} times ==`);
            repeat_num = 0;
          }
          const time = entry.time.toFixed(3);
          const cat = entry.cat ? `${entry.cat}: ` : '';
          console.log(`${time}: ${cat}${entry.text}`);
        } else {
          repeat_num++;
        }
        prev_text = entry.text;
      }
    }

    if (repeat_num) {
      console.log(`== Message repeated ${repeat_num} times ==`);
    }
  }

  private getLogs(all?: boolean): LegacyLogEntry[] {
    const logs = this.log;
    let result: LegacyLogEntry[];

    //displayed log reduction
    const log_size = 150;
    if (logs.length > 2 * log_size && all !== true) {
      result = logs.slice(0, log_size);
      const tmp_time = result[result.length - 1].time;
      result.push({time: tmp_time, text: '---------------------------------------------'});
      result.push({time: tmp_time, text: 'LOG REDUCED: ' + (logs.length - 2 * log_size) + ' items'});
      result.push({time: tmp_time, text: '---------------------------------------------'});
      result = result.concat(logs.slice(-log_size));
    } else {
      result = logs;
    }

    return result;
  }
}

declare global {
  interface Window {
    /**
     * @deprecated
     */
    log: LegacyLogService;
  }

  /**
   * @deprecated
   */
  const log: LegacyLogService;
}

interface LegacyLogEntry {
  /**
   * Log message
   */
  text: string;

  /**
   * Log Entry Category
   */
  cat?: string;

  /**
   * Date of log entry creation.
   * This is a local date, without any adjustment for time zone or server time.
   */
  time: number;
}
